import './TeamScoreEditRowMobile.scss';

import { Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { UnpyMatch } from 'domain/event/match/UnpyMatch';
import { SystemPointsEnum } from 'domain/event/SystemPoints.enum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import {
  setMatchUpdateModalClose,
  setMatchUpdateModalOpen,
} from 'domain/modal/store/ModalSlice';
import { formatDate } from 'helper/date.helper';
import { NeonText } from 'primary/Components/NeonText/NeonText';
import { IconPodiumByIndex } from 'primary/events/components/PodiumView';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { useDispatch } from 'react-redux';

type TeamScoreEditRowMobileProps = {
  match: UnpyMatch;
  className?: string;
  systemPoint: SystemPointsEnum;
  onEdited: () => void;
  typeEvent: TypeEventCodeEnum;
  isClassementReadOnly?: boolean;
  asView?: boolean;
};

export const TeamScoreEditRowMobile = ({
  systemPoint,
  className,
  match,
  onEdited,
  typeEvent,
  asView,
  isClassementReadOnly,
}: TeamScoreEditRowMobileProps) => {
  const t = useTranslate();
  const dispatch = useDispatch();
  const closeEditScore = () => dispatch(setMatchUpdateModalClose());
  const openEditScore = () => {
    dispatch(
      setMatchUpdateModalOpen({
        //@ts-ignore
        props: {
          systemPoint: systemPoint,
          handleClose: closeEditScore,
          onValidEdit: handleValidateEditScore,
          match: match,
        },
      }),
    );
  };
  const handleValidateEditScore = () => {
    onEdited();
    closeEditScore();
  };
  const participant1 = match.participants?.[0];
  const participant2 = match.participants?.[1];
  const isParticipant1Win =
    participant1?.score != null &&
    participant2?.score != null &&
    participant1?.score > participant2?.score;
  const isParticipant2Win =
    participant2?.score != null &&
    participant1?.score != null &&
    participant2?.score > participant1?.score;
  const scoreP1 =
    typeEvent === TypeEventCodeEnum.LIGUE
      ? `${t(`classement.scoreLabel`)} ${participant1?.score ?? 'N/A'}`
      : participant1?.result
      ? t(`classement.abreviationResult.${isParticipant1Win ? 'WIN' : 'LOOSE'}`)
      : 'N/A';
  const scoreP2 =
    typeEvent === TypeEventCodeEnum.LIGUE
      ? `${t(`classement.scoreLabel`)} ${participant2?.score ?? 'N/A'}`
      : participant2?.result
      ? t(`classement.abreviationResult.${isParticipant2Win ? 'WIN' : 'LOOSE'}`)
      : 'N/A';
  return (
    <div className={classNames('teamScoreEditRowMobile', className)}>
      <div className={classNames('teamScoreEditRowMobile__teams', '-casePart')}>
        <div className={'-teamsContainer'}>
          <div className={'-team'}>
            <div className={'-nameContainer -left'}>
              <span
                className={classNames('-teamName', {
                  '-withoutIcon': !isParticipant1Win,
                })}
              >
                {participant1?.eventParticipant.team?.name ??
                  t('event.matchs.edit.editScore.noTeam')}
              </span>
            </div>
            <div className={'-teamsContainer__scoreWithIcon -left'}>
              <span className={'-teamScore'}>{scoreP1}</span>
              {isParticipant1Win && IconPodiumByIndex[0]}
            </div>
          </div>
          <div className={'-neonVs'}>
            <NeonText variant={'orange'} text={'VS'} />
          </div>
          <div className={'-team'}>
            <div className={'-nameContainer -right'}>
              <span
                className={classNames('-teamName', {
                  '-withoutIcon': !isParticipant2Win,
                })}
              >
                {participant2?.eventParticipant.team?.name ??
                  t('event.matchs.edit.editScore.noTeam')}
              </span>
            </div>
            <div className={'-teamsContainer__scoreWithIcon -right'}>
              <span className={'-teamScore'}>{scoreP2}</span>
              {isParticipant2Win && IconPodiumByIndex[0]}
            </div>
          </div>
        </div>
        {!asView && (
          <div className={'-actionContainer'}>
            <span className={'-date'}>
              {match.startDate
                ? formatDate(match.startDate, 'readable(with hour)')
                : '--/--/----'}
            </span>
            <Button
              color={'primary'}
              style={{ justifySelf: 'flex-end' }}
              variant={'text'}
              onClick={openEditScore}
              disabled={isClassementReadOnly}
            >
              <Edit />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
